import { addSlidesTabIndex } from '@gravity-global/helpers/swiper/add-slides-tab-index';

const caseStudySlider = () => {
  const mainPattern = document.querySelectorAll('.gg-case-study-slider-v2');

  mainPattern.forEach((module) => {
    const swipers = module.querySelector('.posts-result');
    const swiperWrapper = module.querySelector('.gravity-block-dynamic-boxes--grid-view');
    const groupButton = module.querySelector('.case-study-button');
    const groupWrappers = module.querySelectorAll('.gravity-block-dynamic-boxes__group-wrapper');
    const dynamicBox = module.querySelectorAll('.gravity-block-dynamic-boxes__box');
    if (!swipers || !swiperWrapper) {
      return;
    }
    

    // get all element .gravity-block-dynamic-boxes__title if it exists then get content and add into content 2 quote ("") in content h2
    groupWrappers.forEach((wrapper) => {
      const title = wrapper.querySelector('.gravity-block-dynamic-boxes__title');
      if (title) {
        const content = title.textContent;
        const contentWithQuotes = `&ldquo;${content.trim()}&rdquo;`;
        title.innerHTML = `<h2>${contentWithQuotes}</h2>`;
      }
      const titleV2 = wrapper.querySelector('.gravity-block-dynamic-boxes__case-study-title-testimonial');
      if (titleV2) {
        const content = titleV2.textContent;
        const contentWithQuotes = `&ldquo;${content.trim()}&rdquo;`;
        titleV2.innerHTML = `${contentWithQuotes}`;
      }
    });



    const swiperSlides = module.querySelectorAll('.gravity-block-dynamic-boxes__box');
    const swiperNext = module.querySelector('.gg-carousel-horizontal-overflowed__next-btn > a');
    const swiperPrev = module.querySelector('.gg-carousel-horizontal-overflowed__prev-btn > a');

    if (swiperPrev) swiperPrev.setAttribute('rel', 'prev');
    if (swiperNext) swiperNext.setAttribute('rel', 'next');

    swipers.classList.add('swiper-container');
    swiperWrapper.classList.add('swiper-wrapper');
    swiperSlides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });

    if (dynamicBox <= 1) {
      groupButton.classList.add('d-none');
    } else {
      const carousel = new window.Swiper(swipers, {
        loop: true,
        autoHeight: true,
        allowTouchMove: true,
        speed: 500,
        slidesPerGroup: 1,
        slidesPerView: 1,
        navigation: {
          prevEl: swiperPrev,
          nextEl: swiperNext,
        },
        on: {
          slideChangeTransitionEnd: (swiper) => {
            swiper.updateAutoHeight(0);
          },
        },
      });
      const images = document.querySelectorAll('.swiper-slide img');

      images.forEach((img) => {
        img.addEventListener('load', () => {
          carousel.updateAutoHeight();
        });
      });

    }
  });
};
caseStudySlider();
